<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <form role="form" name="emailDocumentsForm" id="emailDocumentsForm" novalidate>
                <div class="col-xs-12 border px-4 pt-4 pb-3">
                    <div class="available-documents-container">
                        <div class="col-xs-4 pl-0 pr-5">
                            <app-documents-tree *ngIf="!loadingFolders"
                                [folders]="folders"
                                [isJobMatchFolders]="false"
                                [isAvailableDocuments]="true"
                                [availableDocumentsInFolders]="availableDocuments"
                                customStyle="height: 250px"
                                (onSelectFolderWithDocuments)="selectFolderWithDocuments($event.folder)"
                                (onSelectAndDeselectDocument)="selectAndDeselectDocument($event.document, $event.folder)">
                            </app-documents-tree>
                            <app-documents-tree *ngIf="!loadingFolders"
                                [folders]="candidateJobMatchFolders"
                                [isJobMatchFolders]="true"
                                [isAvailableDocuments]="true"
                                customStyle="height: 230px"
                                (onSelectFolderWithDocuments)="selectFolderWithDocuments($event.folder)"
                                (onSelectAndDeselectDocument)="selectAndDeselectDocument($event.document, $event.folder)">
                            </app-documents-tree>
                            <!-- Folder tree skeleton -->
                            <div *ngIf="loadingFolders" class="skeleton-container p-2" style="height:480px">
                                <div class="d-flex align-items-center mb-4" *ngFor="let placeholderFolder of skeletonPlaceholderFolders">
                                    <div class="skeleton-img skeleton-loading mr-2" style="width:16px;height:16px;border-radius:3px;"></div>
                                    <div class="skeleton-heading skeleton-loading" [ngClass]="placeholderFolder"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-8">
                            <div class="col-xs-12 px-0 py-3">
                                <span class="text-muted d-block font-bold"
                                    style="font-size:12px;">SELECTED DOCUMENTS</span>
                            </div>
                            <div class="col-xs-12 px-0" style="height: 500px; overflow-y: auto;" *ngIf="attachedDocuments.length>0">
                                <div class="col-xs-4 pl-0" *ngFor="let file of attachedDocuments">
                                    <div class="position-relative d-flex flex-column rounded border p-4 available-document"
                                        [ngClass]="{'bg-purple': file.shared, 'candidate-document-selected-bg': file.selected}"
                                        (dblclick)="viewDocumentFIle(file)">
                                        <div class="position-absolute" style="left:10px; top:4px">
                                            <small tooltip="Document version" container="body" [adaptivePosition]="false">V{{file.version}}</small>
                                        </div>
                                        <div class="position-absolute d-flex" style="top:5px;right:7px;">
                                            <a (click)="selectAndDeselectDocument(file, null)" tooltip="Remove Document" container="body" [adaptivePosition]="false">
                                                <i class="fas fa-minus-circle text-danger" style="font-size:20px"></i>
                                            </a>
                                        </div>
                                        <div class="border-bottom d-flex justify-content-center align-items-center cursor-pointer">
                                            <img
                                                class="pb-3"
                                                [src]="file.icon"
                                                alt=""
                                                style="height:80px">
                                            <i *ngIf="file.note && file.note.length>0" class="fas fa-clipboard text-primary" tooltip="{{file.note}}" container="body" [adaptivePosition]="false"></i>
                                        </div>
                                        <div>
                                            <strong class="p-2 d-block text-overflow-ellipsis" container="body" tooltip="{{file.displayFileName || file.fileName}}" [adaptivePosition]="false" style="max-width: 160px;">{{file.displayFileName || file.fileName}}</strong>
                                            <small class="pull-left pt-2 text-muted" *ngIf="file.shared && file.sharedTo.length>0">
                                                {{file.sharedToText}}
                                                <i class="fas fa-share-alt text-primary"
                                                    [popover]="clientsPopover"
                                                    popoverTitle="Shared with"
                                                    triggers="mouseenter">
                                                </i>
                                                <ng-template #clientsPopover>
                                                    <div *ngFor="let client of file.sharedTo">
                                                        <span class="d-block">{{client.shortName}}</span>
                                                    </div>
                                                </ng-template>
                                            </small>
                                            <small *ngIf="file.uploadedDate" class="pull-right pt-2 text-muted" tooltip="Uploaded On" container="body" [adaptivePosition]="false">
                                                {{file.uploadedDate | fourDotFiveDateFormatPipe}}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="attachedDocuments.length===0" class="flex-grow-1 text-muted pt-5 pl-5" style="margin-top: 26px;">
                                No documents available
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 text-right mt-2">
                        <div class="clearfix">
                            <button type="button" class="btn btn-danger mr-2" (click)="cancel()" [disabled]="savingFlag">
                                <span>Cancel</span>
                            </button>
                            <button type="submit" class="btn btn-success" (click)="attachDocuments()" [disabled]="savingFlag || attachedDocuments.length===0">
                                <span *ngIf="!savingFlag">Attach</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
